<div
    class="vehicle-detail-container flex flex-column gap-4 justify-content-center align-items-center"
>
    <p-card
        class="w-full"

        *ngIf="vehicle"
    >
        <ng-container #title>
            <div class="mb-4 flex align-items-center gap-3 justify-content-start">
                <p-button (click)="goToVehiclesListing()" icon="pi pi-arrow-left" [rounded]="true" [raised]="true" [text]="true" severity="danger" />
                <span class="p-card-title mb-0">{{ vehicle.vehicle.model.make.name }} /
                    {{ vehicle.vehicle.model.name }} ({{
                        vehicle.vehicle.yearOfManufacture
                    }}
                    {{ "MODEL" | translate }})</span>
            </div>
        </ng-container>
        <ng-container #subtitle *ngIf="vehicle.vehicle.status === 'PENDING_DOCUMENT_SUBMISSION'">
            <div class="mb-4 flex align-items-center gap-3 justify-content-start">
                <p-message severity="warn" size="large" [text]="'UPLOAD_REQUIRED_DOCUMENTS' | translate"></p-message>
            </div>
        </ng-container>
        <div class="border-300 border-top-1 pt-4 flex flex-column">
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        vehicle.vehicle.registrationNumber
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "VEHICLE_REGISTRATION_NUMBER" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        vehicle.vehicle.vehicleValue | currency : "MZN" + " "
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "VEHICLE_VALUE" | translate
                    }}</span>
                </div>
            
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900"
                        >{{ vehicle.vehicle.carryingCapacity }}
                        {{ "Seater" | translate }}</span
                    >
                    <span class="text-500 text-sm">{{
                        "CARRYING_CAPACITY" | translate
                    }}</span>
                </div>
            </div>
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900"
                        >{{
                            vehicle.vehicle.weightCategory.name | translate
                        }}
                        ({{
                            vehicle.vehicle.weightCategory.description | translate
                        }})</span
                    >
                    <span class="text-500 text-sm">{{
                        "WEIGHT_CATEGORY" | translate
                    }}</span>
                </div>

                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        vehicle.vehicle.vehicleUse.description | translate
                    }}</span>
                    <span class="text-500 text-sm">{{'VEHICLE_USAGE' | translate}}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        vehicle.vehicle.vehicleType.description | translate
                    }}</span>
                    <span class="text-500 text-sm">{{'VEHICLE_TYPE' | translate}}</span>
                </div>
            </div>
        </div>
    </p-card>
    <div class="w-full" *ngIf="vehicle && vehicle.documents.length > 0">
        <app-show-documents
            [documents]="vehicle.documents"
        ></app-show-documents>
    </div>
    <div
        class="w-full"
        *ngIf="vehicle && vehicle.outstandingDocuments.length > 0"
    >
        <p-messages [(value)]="messages" [closable]="true" />
        <app-show-outstanding-documents
            [ownerId]="vehicle.vehicle.id"
            *ngIf="vehicle"
            [outstandingDocuments]="vehicle.outstandingDocuments"
            [identifier]="'Vehicle'"
            (onUploadDocument)="documentUploaded($event)"
        ></app-show-outstanding-documents>
    </div>
</div>
